const TOPICS = [
  { name: '下拉式漫画阅读', count: '2.3万讨论', hot: true },
  { name: '鬼灭之刃', count: '5.8万讨论', hot: true },
  { name: '无弹窗漫画', count: '1.6万讨论', hot: true },
  { name: '咒术回战', count: '4.2万讨论', hot: true },
  { name: '翻页漫画', count: '1.1万讨论', hot: false },
  { name: '漫画全屏观看', count: '9,800讨论', hot: true },
  { name: '海贼王', count: '8.5万讨论', hot: true },
  { name: '免费漫画', count: '3.7万讨论', hot: false },
  { name: '间谍过家家', count: '2.9万讨论', hot: true },
  { name: '在线阅读', count: '2.1万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex w-12 h-12 rounded-2xl bg-accent-100 items-center justify-center mb-4">
            <i className="ri-hashtag text-accent-600 text-2xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500">看看大家都在讨论什么</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((t) => (
            <a
              key={t.name}
              href="#cards"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                t.hot
                  ? 'bg-accent-50 border-accent-200 text-accent-700 hover:bg-accent-100 hover:border-accent-300'
                  : 'bg-background-50 border-background-200 text-foreground-600 hover:border-primary-300 hover:bg-primary-50/30'
              }`}
            >
              {t.hot && <i className="ri-fire-line text-accent-500 text-xs"></i>}
              <span>{t.name}</span>
              <span className="text-[11px] opacity-60">{t.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}